import React from 'react';

type AddCircleProps = {
  className?: string;
};

export function AddCircleIcon({ className }: AddCircleProps): JSX.Element {
  return (
    <div className={className}>
      <svg
        fill='none'
        height='21'
        style={{ backgroundColor: 'transparent' }}
        viewBox='0 0 21 21'
        width='21'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g id='add-circle'>
          <path
            clipRule='evenodd'
            d='M10.5 5.94995C10.8383 5.94995 11.1125 6.22418 11.1125 6.56245V14.4375C11.1125 14.7757 10.8383 15.05 10.5 15.05C10.1618 15.05 9.88753 14.7757 9.88753 14.4375V6.56245C9.88753 6.22418 10.1618 5.94995 10.5 5.94995Z'
            fill='#454E50'
            fillRule='evenodd'
            id='vector'
          />
          <path
            clipRule='evenodd'
            d='M5.95003 10.5C5.95003 10.1617 6.22425 9.88745 6.56253 9.88745H14.4375C14.7758 9.88745 15.05 10.1617 15.05 10.5C15.05 10.8382 14.7758 11.1125 14.4375 11.1125H6.56253C6.22425 11.1125 5.95003 10.8382 5.95003 10.5Z'
            fill='#454E50'
            fillRule='evenodd'
            id='vector_2'
          />
          <path
            clipRule='evenodd'
            d='M3.10634 3.10627C5.06727 1.14534 7.72686 0.0437012 10.5 0.0437012C13.2732 0.0437012 15.9328 1.14534 17.8937 3.10627C19.8546 5.06719 20.9563 7.72678 20.9563 10.5C20.9563 13.2731 19.8546 15.9327 17.8937 17.8936C15.9328 19.8546 13.2732 20.9562 10.5 20.9562C7.72686 20.9562 5.06727 19.8546 3.10634 17.8936C1.14541 15.9327 0.0437775 13.2731 0.0437775 10.5C0.0437775 7.72678 1.14541 5.06719 3.10634 3.10627ZM10.5 1.2687C8.05175 1.2687 5.70374 2.24128 3.97255 3.97247C2.24135 5.70367 1.26878 8.05167 1.26878 10.5C1.26878 12.9482 2.24135 15.2962 3.97255 17.0274C5.70374 18.7586 8.05175 19.7312 10.5 19.7312C12.9483 19.7312 15.2963 18.7586 17.0275 17.0274C18.7587 15.2962 19.7313 12.9482 19.7313 10.5C19.7313 8.05167 18.7587 5.70367 17.0275 3.97247C15.2963 2.24128 12.9483 1.2687 10.5 1.2687Z'
            fill='#454E50'
            fillRule='evenodd'
            id='vector_3'
          />
        </g>
      </svg>
    </div>
  );
}
